import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {Router} from '@angular/router';

import {ToastsManager} from 'ng6-toastr';
import {HttpParams} from '@angular/common/http';
import {RequestsService} from '../services/requests.service';
import {AppConfig} from '../config/app.config';
import {GeneratSetting} from '../source/general_settings/generatSetting';
import {SharedService} from '../services/SharedService';
import {MessagingService} from '../services/messagingService';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: []
})
export class LoginComponent implements OnInit {

  // Settings
  login_heading: string;
  login_text: string;

  // Login
  email: string;
  password: string;

  // disabled button
  loginBtnDisabled: boolean = false;

  user_id: any;
  store_id: any;
  enableQuickAccess:number;
  enableClockInOut:number;



  constructor(
    private router: Router,
    public toastr: ToastsManager,
    vcr: ViewContainerRef,
    private requestsService: RequestsService,
    private sharedService: SharedService,
    private messagingService: MessagingService
  ) {
    this.toastr.setRootViewContainerRef(vcr);
  }




  
  ngOnInit() {
    // ✅ Move redirect logic here — safe after Angular initialization
    const token = window.localStorage.getItem(btoa('access_token'));
    if (token && token !== 'null') {
      this.router.navigate(['/home']);
      return;
    }

    // Load login screen settings
    this.requestsService.getSettingsRequest('auth/settings').subscribe((response: Response) => {
      this.login_heading = response['login_heading'];
      this.login_text = response['login_text'];
      this.enableQuickAccess = response['enableQuickAccess'];
      this.enableClockInOut = response['enableClockInOut'];
    });
  }

  requestPermissionForToken(userId, storeId) {
    this.messagingService.requestPermission(userId, storeId);
  }





  onClickSubmit() {
    this.loginBtnDisabled = true;
    let body = new HttpParams();
    body = body.set('email', this.email);
    body = body.set('password', this.password);
    body = body.set('device_type', 'web');
    body = body.set('grantType', 'password');

    return this.requestsService.postRequestauthToken('auth/token', body).subscribe((response: Response) => {

      if (response['result_type'] === 'Success') {
        if (response['token_data']['token_type'] === 'Bearer') {
          window.localStorage.setItem(btoa('access_token'), btoa(response['token_data']['access_token']));
          window.localStorage.setItem(btoa('expire_in'), btoa(response['token_data']['expires_in']));
          window.localStorage.setItem(btoa('token_type'), btoa(response['token_data']['token_type']));
          window.localStorage.setItem(btoa('user'), btoa(JSON.stringify(response['user_data'])));
          window.localStorage.setItem(btoa('multi_stores'), btoa(JSON.stringify(response['stores_info']['multi_stores'])));
          window.localStorage.setItem(btoa('store_count'), btoa(JSON.stringify(response['stores_info']['count'])));
          this.user_id = response['user_data'].user_id;
          if (response['store_data'] != '') {
            window.localStorage.setItem(btoa('store_data'), btoa(JSON.stringify(response['store_data'])));
            window.localStorage.setItem(btoa('store_order_number'), btoa(JSON.stringify(response['store_data']['current_store_order_number'])));
            window.localStorage.setItem(btoa('original_store_order_number'), btoa(JSON.stringify(response['store_data']['store_order_number'])));
            this.store_id = response['store_data'].store_id;
          }
          if (response['register'] != '') {
            window.localStorage.setItem(btoa('register'), btoa(JSON.stringify(response['register'])));
          }
          if (response['general_settings'] != '') {
            window.localStorage.setItem(btoa('general_settings'), btoa(unescape(encodeURIComponent(JSON.stringify(response['general_settings'])))));
          }
          if (response['features_detail'] != '') {
            window.localStorage.setItem(btoa('features_detail'), btoa(unescape(encodeURIComponent(JSON.stringify(response['features_detail'])))));
          }
          if (response['user_permission'] != '') {
            window.localStorage.setItem(btoa('user_permission'), btoa(JSON.stringify(response['user_permission'])));
          } else {
            var permission = [];
            window.localStorage.setItem(btoa('user_permission'), btoa(JSON.stringify(permission)));
          }
          window.localStorage.setItem("screen_locked","1");

          if (this.enableQuickAccess == 1) {
            console.log('Redirecting to /locking');
            this.router.navigate(['/locking']).then(() => {
              console.log('Navigation to /locking complete');
            });
          } else {
            this.router.navigate(['/home']);
          }
          this.requestPermissionForToken(this.user_id, this.store_id);
        
        }
      } else {
        window.localStorage.removeItem(btoa('access_token'));
        window.localStorage.removeItem(btoa('expire_in'));
        window.localStorage.removeItem(btoa('token_type'));
        window.localStorage.removeItem(btoa('user_permission'));
        window.localStorage.removeItem(btoa('register'));

        window.localStorage.removeItem(btoa('user'));
        if (response['store_data'] != '') {
          window.localStorage.removeItem(btoa('store_data'));
        }
        if (response['features_detail'] != '') {
          window.localStorage.removeItem(btoa('features_detail'));
        }
        this.toastr.error(response['message'], response['result_type']);
        this.router.navigate(['/login']);
      }
      this.loginBtnDisabled = false;
    });

  }
}


@Component({
  selector: 'app-logout',
  templateUrl: './login.component.html',
  styleUrls: []
})
export class LogoutComponent implements OnInit {

  // Settings
  login_heading: string;
  login_text: string;

  // Login
  email: string;
  password: string;

  // disabled button
  loginBtnDisabled = false;

  constructor(private router: Router) {

  }

  ngOnInit() {
    window.localStorage.clear();
    this.router.navigate(['/login']);
  }

  onClickSubmit() {

  }

}
